import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  private preloadedModules: string[] = [];

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (this.shouldPreload(route)) {
      console.log('Preloading: ' + route.path);
      this.preloadedModules.push(route.path || '');
      return load();
    } else {
      return of(null);
    }
  }

  getPreloadedModules(): string[] {
    return this.preloadedModules;
  }

  private shouldPreload(route: Route): boolean {
    // Preload routes marked with data.preload = true
    return route.data?.['preload'] === true;
  }
}